module.exports = __webpack_public_path__ + "static/north-america-a1a21c3093cc370c9d338e374a2dc587.svg";